import './theme.css'
import './pages.css'
import './controls.css'
import type { ThemeMode, ThemeTokens } from '@/app/branding'

export const dashboardTheme = {
  id: '6',
  name: 'Clarity',
  defaultMode: 'light',
  tokens: {
    light: {
      background: '#F5F6FA',
      backgroundElevated: '#FFFFFF',
      sidebar: '#141A2B',
      surface: '#FFFFFF',
      surfaceMuted: '#F3F4F8',
      text: '#20273C',
      textMuted: '#647085',
      textFaint: '#68748B',
      border: '#E4E8F0',
      borderStrong: '#C6CCDD',
      primary: '#4F5CF0',
      primaryText: '#4953C6',
      primaryHover: '#424ED7',
      onPrimary: '#FFFFFF',
      primarySoft: '#F0F1FF',
      success: '#167655',
      warning: '#926015',
      danger: '#BD3F4B',
      focus: '#4F5CF0',
      chart: ['#6572E8', '#64A3E5', '#60B49C', '#B98632'],
    },
    dark: {
      background: '#101522',
      backgroundElevated: '#1B2337',
      sidebar: '#101522',
      surface: '#182033',
      surfaceMuted: '#232D43',
      text: '#F0F3FC',
      textMuted: '#ACB8CE',
      textFaint: '#9CAAC1',
      border: '#303B53',
      borderStrong: '#4D5B77',
      primary: '#5965DF',
      primaryText: '#B5BDFF',
      primaryHover: '#626FE8',
      onPrimary: '#FFFFFF',
      primarySoft: '#293359',
      success: '#7DD6AE',
      warning: '#E8C17C',
      danger: '#FF95A2',
      focus: '#9CA7FF',
      chart: ['#9CA7FF', '#79B9EF', '#7DD6AE', '#E8C17C'],
    },
  },
} satisfies { id: string; name: string; defaultMode: ThemeMode; tokens: Record<ThemeMode, ThemeTokens> }
